import routes from './routes';
import SetRoutes from '../../components/setRoutes';

const BillingPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default BillingPages;
